import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getScheduleAnalyses = asyncThunkWrapper({ 
  model: 'scheduleAnalyses', 
  action: 'getScheduleAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/schedule_flow/schedule_analyses', { params });

    return response.data;
  } 
});
export const getScheduleAnalysis = asyncThunkWrapper({ 
  model: 'scheduleAnalyses', 
  action: 'getScheduleAnalysis', 
  func: async ({ id, cable = false },) => {
    const attributes = ['id', { patient: ['id', 'first_name', 'last_name' ]}, 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/schedule_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalScheduleAnalyses = createAction('scheduleAnalyses/clearLocalScheduleAnalyses');
export const clearLocalActiveScheduleAnalysis = createAction('scheduleAnalyses/clearLocalActiveScheduleAnalysis');